module.exports = __webpack_public_path__ + "static/media/Project1_Fig15.399e78ae.png";